import React, { useState } from 'react';
import { LayoutComposer } from '../../components';
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';
import FooterContainer from '../../containers/FooterContainer/FooterContainer';
import { NamedLink } from '../../components';
import classNames from 'classnames';
import css from './FAQPage.module.css';

const FAQ_DATA = [
  {
    question: "¿Qué es exactamente BioCerca?",
    answer: (
      <>
        <p>Es un Marketplace que conecta directamente a agricultores con personas que quieren comprar productos reales, de forma local y sin intermediarios.</p>
        <p>Aquí eliges tú: qué, a quién, y dónde recogerlo.</p>
        <p>Es más que una compra: es un reencuentro con lo natural.</p>
        <p>Una comunidad.</p>
      </>
    )
  },
  {
    question: "¿Puedo unirme, aunque no tenga huerto ni gallinas?",
    answer: (
      <>
        <p>¡Claro que sí!</p>
        <p>BioCerca es para quienes cultivan… pero también para quienes valoran lo que otros cultivan.</p>
        <p>Solo necesitas ganas de volver a lo auténtico (y apetito por lo bueno).</p>
      </>
    )
  },
  {
    question: "¿Esto es una tienda online?",
    answer: (
      <>
        <p>No exactamente.</p>
        <p>No hay almacenes. No hay envíos.</p>
        <p>En BioCerca tú eliges productos de varios agricultores y pagas en un solo clic. Luego acuerdas con cada uno el mejor momento para recoger tu compra.</p>
        <p>Así de claro. Así de humano.</p>
      </>
    )
  },
  {
    question: "¿Cuándo empieza todo esto?",
    answer: (
      <>
        <p>Ya ha empezado. Estás dentro.</p>
        <p>La plataforma está abierta y en crecimiento.</p>
        <p>Es posible que al principio veas pocos agricultores cerca, pero si te unes, ayudas a que la comunidad crezca. Cada nuevo usuario suma. Cada compra cuenta.</p>
      </>
    )
  },
  {
    question: "¿Dónde recojo lo que compro?",
    answer: (
      <>
        <p>Cada agricultor define su punto de recogida: en su finca, en el mercado local o en un lugar acordado.</p>
        <p>Después de comprar, ellos te contactan para acordar día y hora.</p>
        <p>Y si te apetece, puedes aprovechar para conocerles y ver cómo cultivan.</p>
      </>
    )
  },
  {
    question: "¿Hay productos ecológicos?",
    answer: (
      <>
        <p>Sí, muchos agricultores trabajan en ecológico.</p>
        <p>Cada uno lo indicará en su perfil, junto con sus métodos de cultivo.</p>
        <p>Tú eliges en quién confías y cómo quieres comer.</p>
      </>
    )
  },
  {
    question: "¿Puedo llevar a mis hijos a la granja?",
    answer: (
      <>
        <p>¡Ojalá lo hagas!</p>
        <p>Muchos agricultores estarán encantados de recibir visitas.</p>
        <p>Es una forma maravillosa de enseñar a los peques de dónde viene la comida (y que no crece en bandejas de plástico).</p>
      </>
    )
  },
  {
    question: "¿Y si no sé qué cocinar con lo que compro?",
    answer: (
      <>
        <p>Tranquila. Para eso está nuestra sección de recetas.</p>
        <p>Ideas fáciles, sabrosas y originales para sacarle partido a lo que compras.</p>
        <p>Comer bien empieza por elegir mejor… y continúa en la cocina con alegría.</p>
      </>
    )
  },
  {
    question: "¿Cómo puedo invitar a más personas a BioCerca?",
    answer: (
      <>
        <p>Muy fácil: comparte la web con tus amigos, familia o vecinos.</p>
        <p>Cuéntales tu experiencia, recomiéndales tu perfil o el de un agricultor, invítales a probar.</p>
        <p>Cada persona que se une hace que el mapa se llene de vida.</p>
        <p>Y si tienes una comunidad, un proyecto o incluso una tienda, puedes colaborar oficialmente con BioCerca.</p>
        <p>
          <strong>
            <a href="https://www.biocerca.es" target="_blank" rel="noopener noreferrer" className={css.link}>www.biocerca.es</a>
          </strong>
        </p>
      </>
    )
  }
];

const FAQPage = () => {
    const [openIndex, setOpenIndex] = useState(null);

    const toggleAccordion = index => {
        setOpenIndex(openIndex === index ? null : index);
    };

    const layoutAreas = `
        topbar
        main
        footer
    `;

    return (
        <LayoutComposer areas={layoutAreas} className={css.root}>
            {layoutProps => {
                const { Topbar, Main, Footer } = layoutProps;
                return (
                    <>
                        <Topbar as="header" className={css.topbar}>
                            <TopbarContainer currentPage="FAQPage" />
                        </Topbar>
                        <Main as="main" className={css.main}>
                            <div className={css.content}>
                                <h1 className={css.title}>Preguntas Frecuentes (FAQ)</h1>
                                <div className={css.accordion}>
                                    {FAQ_DATA.map((item, index) => (
                                        <div key={index} className={classNames(css.item, { [css.isOpen]: openIndex === index })}>
                                            <button className={css.question} onClick={() => toggleAccordion(index)}>
                                                {item.question}
                                                <span className={css.icon}>{openIndex === index ? '−' : '+'}</span>
                                            </button>
                                            <div
                                                className={css.answerWrapper}
                                                style={{ maxHeight: openIndex === index ? '1000px' : '0' }}
                                            >
                                                <div className={css.answer}>{item.answer}</div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </Main>
                        <Footer>
                            <FooterContainer />
                        </Footer>
                    </>
                );
            }}
        </LayoutComposer>
    );
};

export default FAQPage;
